import {
  AfterViewInit,
  AfterContentInit,
  AfterViewChecked,
  Component,
  effect,
  ElementRef,
  Inject,
  Input,
  inject,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  ViewChild,
  DOCUMENT
} from '@angular/core';
import { ChatbotRestService } from '../core/services/api/chatbot.rest-service';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ScriptService } from '../core/services/utility/scripts.service';
import { ChatbotService } from '../core/services/chatbot.service';
import { Router, NavigationEnd } from '@angular/router';
import { UrlService } from '../core/services/url.service';

declare let require: any;

@Component({
  selector: 'app-chatbot-mini',
  templateUrl: './chatbot-mini.component.html',
  styleUrls: ['./chatbot-mini.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatbotMiniComponent implements OnInit, OnDestroy, AfterContentInit {
  private ngUnsubscribe$ = new Subject<void>();
  @ViewChild('chatbotMini') chatbotMini!: ElementRef;
  private webchat: any;
  private webby: any;
  token: string = null;
  size: string;
  full = false;
  public open = 'open';
  @Input() path = null;
  s2 = null;
  chatm = null;
  urlService = inject(UrlService);
  teaser = null;

  constructor(
      private chatbotRestService: ChatbotRestService,
      private chatbotService: ChatbotService,
      private scriptService: ScriptService,
      @Inject(DOCUMENT) private document,
      @Inject('WEBCHAT_MINI') private WEBCHAT_MINI
  ) {
    effect(() => {
      // if (this.urlService.currentPath() !== null && this.path?.indexOf('dashboard') === -1) {
        if(this.chatbotService.chatbotToken() && this.s2 === null){
          this.initChatbot()
        }

        if(this.teaser !== null) {
          this.addSubClass();
        }
      // }
    })
  }

  initChatbot(){
    this.scriptService.loadScript('tcom').then(webby => {
      this.scriptService.loadScript('minibot').then(chatty => {
        const mini = this.document.getElementById('phx-chatbot-mini');
        this.s2 = this.document.createElement('script');
        this.s2.classList = "mini-chat";
        const node = this.document.createTextNode('newMinichat("' + this.chatbotService.chatbotToken() + '","' + this.WEBCHAT_MINI + '" )');
        this.s2.appendChild(node);
        mini?.appendChild(this.s2);
        setTimeout(()=>{
          this.teaser = this.document.getElementsByClassName('webchat-teaser-message-root')[0];
          this.addSubClass();
        }, 10000);
      });
    });
  }

  ngOnInit(): void {
    let sub = 0;
    this.chatm = this.document.getElementById('phx-chatbot-mini');
    this.teaser = this.document.getElementsByClassName('webchat-teaser-message-root')[0];
  }

  ngAfterContentInit() {
    this.chatm = this.document.getElementById('phx-chatbot-mini');
    this.teaser = this.document.getElementsByClassName('webchat-teaser-message-root')[0];
  }

  addSubClass () {
    const parent = this.teaser?.parentElement?.parentElement?.classList.add('sub');
  }

  /**
   * Unsubscribe from all subscriptions.
   */
  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    console.log('destroy mini chat');

    if (this.s2 !== null) {
      const close = this.document.createTextNode('closeMiniChat()');
      this.s2.appendChild(close);
      this.s2.remove();
      this.s2 = null;
      this.document.getElementsByClassName('sub')[0]?.remove();
    }
  }
}
